import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import CardThirdPartyServices from '@adv-mt/mt-card-third-party-services'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

import CardCertificationModalContent from './certification-modal-content.js'
import CardCertificationContentList from './certification-service-content-list.js'
import {BASE_CLASS} from './config.js'

const CardCertification = ({certification}) => {
  const {i18n} = useContext(Context)
  const {track} = useAnalyticsTrack()

  const handleToggleModal = ({isOpen}) => isOpen && track({event: 'Certified Cars Program Clicked'})

  const {features = []} = certification
  const contentFeatureList = features.slice(0, 4)

  const thirdPartyInfo = {
    buttonText: i18n.t('CARD_CERTIFICATION_MOTIVATION'),
    customContent: <CardCertificationContentList contentList={contentFeatureList} />,
    modalTitle: i18n.t('CARD_CERTIFICATION_MOTIVATION'),
    text: certification.make,
    title: i18n.t('CARD_CERTIFICATION_TITLE'),
    titleImage: certification.logoUrl
  }

  return (
    <div className={BASE_CLASS}>
      <CardThirdPartyServices
        children={<CardCertificationModalContent contentList={certification.features} />}
        modalCallback={handleToggleModal}
        thirdPartyInfo={thirdPartyInfo}
      />
    </div>
  )
}

CardCertification.displayName = 'CardCertification'
CardCertification.propTypes = {
  certification: PropTypes.shape({
    certificatedProgramId: PropTypes.string,
    logoUrl: PropTypes.string,
    make: PropTypes.string,
    features: PropTypes.arrayOf(
      PropTypes.shape({
        description: PropTypes.string,
        iconUrl: PropTypes.string,
        title: PropTypes.string
      })
    )
  })
}

export default CardCertification
